import Link from 'next/link';
import React from 'react';

// UAE / Malaysia pass `links` [{ label, href }] and `title`; Singapore passes
// its locality names and gets the /sg/.../locality/<name> links.
export const AcServiceLocality = ({ localityList = [], links, title }) => {
  const items = links ?? localityList.filter((loc) => loc !== 'Singapore').map((locality) => ({
    label: locality,
    href: `/sg/aircon-servicing-singapore/locality/${encodeURIComponent(locality)}`,
  }));

  return (
    <section className="leading-7 px-4 py-12 bg-gray-50" aria-label={title ?? "Aircon Servicing Localities"}>
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl font-semibold text-center uppercase text-gray-800 mb-6">
          {title ?? 'Aircon Servicing in Your Neighborhood'}
        </h2>
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-4">
          {items.map((item, i) => (
            <li key={i} className="flex justify-center">
              <Link
                href={item.href}
                prefetch={false}
                className="text-orange-600 text-base hover:underline"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
